<template>
  <div>
    <div class="log-reg-agreement login-display">
      <van-checkbox
        @click.stop="checkboxClick()"
        class="checkbox"
        icon-size="20px"
        v-model="checked"
      ></van-checkbox>
      <label for="Agree"> 我已阅读并同意</label>
      <router-link style="color: #fd6868" to="/userAgreement"
        >《公寓管理用户协议》</router-link
      >和
      <router-link style="color: #fd6868" to="/userPrivacy">《隐私政策》</router-link>
    </div>
  </div>
</template>

<script>
import { siteName } from "../common/const";
export default {
  components: {},
  // 定义属性
  data() {
    return { checked: false };
  },
  computed: {},
  watch: {},
  methods: {
    checkboxClick() {
      this.$emit("click-check", this.checked);
    },
  },
  created() {},
  mounted() {},
};
</script>

<style scoped>
.checkbox {
  display: inline-block;
  vertical-align: middle;
  margin-top: -0.1rem;
  padding-right: 0.5rem;
}
.log-reg-agreement {
  font-size: 0.8rem;
  height: 3rem;
  line-height: 2rem;
  padding: 1rem 0.5rem 0 1.5rem;
}
</style>
